// noinspection GraphQLUnresolvedReference

import { gql } from 'graphql-request'

export const LoteFragment = gql`
  fragment field on Lote {
    _id
    codigoLote
    descripcion
    fechaAdmision
    fechaFabricacion
    fechaVencimiento
    atributo1
    atributo2
    state
    usucre
    createdAt
    usumod
    updatedAt
  }
`
